/**
 * Drawer Content Component
 * 
 * Reusable content wrapper for drawer body with proper styling and layout.
 */

import * as React from "react";
import { Drawer } from "@mantine/core";

interface DrawerContentProps {
  children: React.ReactNode;
}

export const DrawerContent: React.FC<DrawerContentProps> = ({ children }) => {
  return (
    <Drawer.Body className="flex flex-col flex-1 min-h-0 overflow-hidden p-0">
      {children}
    </Drawer.Body>
  );
};
